// extracted by mini-css-extract-plugin
export var container = "_f7-0";
export var dotAnimation = "_f7-2";
export var dotsLoading = "_f7-1";